import { createContext, useContext } from 'react';

export type ImportedGSAP = {
  gsap?: GSAP;
  ScrollTrigger?: ScrollTrigger;
};

export const GsapContext = createContext<ImportedGSAP>({});

export function useGSAP() {
  return useContext(GsapContext);
}
